export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.8-1525.58",
  commitId: "c23478294e7bf366c460ec77099e7083935c5b82",
  commitTime: "2026-09-08T15:25:58.000Z",
});
